<script setup>
import {usePage} from '@inertiajs/vue3';
import {onMounted, watch} from 'vue';
import {Notification, NotificationGroup, notify} from 'notiwind';


onMounted(() => {
    usePage().props.toasts.forEach((toast) => {
        notify(toast, 4000);
    });
});

watch(
    () => usePage().props.toasts,
    (newToasts) => {
        newToasts.forEach((toast) => {
            console.log(toast);
            notify(toast, 4000);
        });
    }
);


</script>

<template>
    <NotificationGroup>
        <div class="pointer-events-none fixed inset-0 z-50 flex items-start justify-end p-6 px-4">
            <div class="w-full max-w-sm">
                <Notification
                    v-slot="{ notifications }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        v-for="notification in notifications"
                        :key="notification.id"
                    >
                        <div

                            class="mx-auto mt-4 flex w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-md"
                        >
                            <div
                                :class="{
                                    'bg-red-500': notification.type === 'error',
                                    'bg-blue-500': notification.type === 'info',
                                    'bg-yellow-500': notification.type === 'warning',
                                    'bg-green-500': notification.type === 'success',
                                }"
                                class="flex w-12 items-center justify-center"
                            >
                                <svg
                                    class="size-6 fill-current text-white"
                                    viewBox="0 0 40 40"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z"
                                    />
                                </svg>
                            </div>

                            <div class="-mx-3 px-4 py-2">
                                <div class="mx-3">
                                    <span class="font-semibold">{{ notification.title }}</span>
                                    <p class="text-sm text-gray-600">
                                        {{ notification.text }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>
</template>

